import { RectangleStackIcon } from '@heroicons/react/24/outline';
import ProgramCard from '../../components/programs/ProgramCard';
import { Program } from '../../types/program';
import { exampleOptions } from './cardReviewStorage';
import { programScent } from './scentViews';
import { ExampleSwitcher, FamilyBlock } from './reviewUi';

function SearchLine({ program }: { program: Program }) {
  const introduction = program.introduction?.trim();
  return (
    <div className="flex items-start gap-3 p-4 bg-white border border-gray-200 rounded-lg">
      <RectangleStackIcon className="h-5 w-5 text-primary flex-shrink-0 mt-0.5" aria-hidden />
      <div className="min-w-0">
        <p className="text-xs font-semibold uppercase tracking-wide text-primary mb-0.5">Program</p>
        <h4 className="font-semibold text-gray-900 mb-1 line-clamp-1">{program.title}</h4>
        {introduction && <p className="text-sm text-gray-600 line-clamp-2">{introduction}</p>}
      </div>
    </div>
  );
}

export default function ProgramReview({
  program,
  bloodyEasy,
  notice,
  error,
  choices,
  onChoose,
  notes,
  onNote,
}: {
  program: Program | null;
  bloodyEasy: Program | null;
  notice: string | null;
  error: string | null;
  choices: Record<string, string>;
  onChoose: (exampleId: string, optionId: string) => void;
  notes: Record<string, string>;
  onNote: (exampleId: string, note: string) => void;
}) {
  const showBloodyEasy = Boolean(bloodyEasy && bloodyEasy.id !== program?.id);
  return (
    <FamilyBlock
      id="review-programs"
      title="Programs"
      judge="Type rail draws a program as a room with its hubs listed inside. The other options stay specific to this place."
      destination="A program card opens the program."
      notice={notice}
      error={error}
    >
      {program && (
        <>
          <ExampleSwitcher
            exampleId="programs-index"
            label="Programs index and search"
            options={exampleOptions('programs-index')}
            choice={choices['programs-index'] ?? ''}
            onChoose={(optionId) => onChoose('programs-index', optionId)}
            note={notes['programs-index'] ?? ''}
            onNote={(value) => onNote('programs-index', value)}
            render={(optionId) =>
              optionId === 'current' ? <ProgramCard program={program} /> : programScent(program, optionId)
            }
          />
          <ExampleSwitcher
            exampleId="programs-search"
            label="Header search"
            options={exampleOptions('programs-search')}
            choice={choices['programs-search'] ?? ''}
            onChoose={(optionId) => onChoose('programs-search', optionId)}
            note={notes['programs-search'] ?? ''}
            onNote={(value) => onNote('programs-search', value)}
            render={(optionId) =>
              optionId === 'current' ? <SearchLine program={program} /> : programScent(program, optionId)
            }
          />
        </>
      )}
      {showBloodyEasy && bloodyEasy && (
        <ExampleSwitcher
          exampleId="programs-bloody-easy"
          label="Programs index, Bloody Easy"
          options={exampleOptions('programs-bloody-easy')}
          choice={choices['programs-bloody-easy'] ?? ''}
          onChoose={(optionId) => onChoose('programs-bloody-easy', optionId)}
          note={notes['programs-bloody-easy'] ?? ''}
          onNote={(value) => onNote('programs-bloody-easy', value)}
          render={(optionId) =>
            optionId === 'current' ? <ProgramCard program={bloodyEasy} /> : programScent(bloodyEasy, optionId)
          }
        />
      )}
    </FamilyBlock>
  );
}
